import 'css-chunksrc/client/scenes/projectCreation/styles.scss';export default {
  "form": "_form_p0fie_1",
  "buttons": "_buttons_p0fie_11",
  "button": "_button_p0fie_11"
};